import Card from '../../components/ui/Card'
import Badge from '../../components/ui/Badge'
import Dropdown from '../../components/ui/Dropdown'
import { formatCurrency, formatDate } from '../../lib/format'

function SubscriptionCard({ subscription, onEdit, onDelete }) {
  const statusBadge = {
    active: <Badge variant="active">Active</Badge>,
    cancelled: <Badge variant="paused">Cancelled</Badge>,
    paused: <Badge variant="paused">Paused</Badge>,
  }

  const billingLabel = subscription.billing_cycle === 'yearly' ? '/year' : '/month'

  return (
    <Card className="subscription-card">
      <div className="flex justify-between items-center mb-3">
        <div className="flex items-center gap-2">
          {subscription.businesses && (
            <span className="text-lg">{subscription.businesses.emoji}</span>
          )}
          <h4 className="font-medium">{subscription.name}</h4>
        </div>
        <Dropdown
          trigger={<button className="btn btn-ghost btn-sm">⋯</button>}
        >
          <Dropdown.Item onClick={() => onEdit(subscription)}>
            ✏️ Edit
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => onDelete(subscription.id)} danger>
            🗑️ Delete
          </Dropdown.Item>
        </Dropdown>
      </div>

      <div className="flex justify-between items-center mb-3">
        <span className="text-2xl font-bold">
          {formatCurrency(subscription.amount)}
          <span className="text-sm text-muted font-normal">{billingLabel}</span>
        </span>
        {statusBadge[subscription.status] || statusBadge.active}
      </div>

      {subscription.businesses && (
        <p className="text-sm text-muted mb-2">
          {subscription.businesses.name}
        </p>
      )}

      <div className="text-sm text-muted">
        {subscription.next_billing_date ? (
          <>Next billing: {formatDate(subscription.next_billing_date)}</>
        ) : (
          <>Started: {formatDate(subscription.start_date || subscription.created_at)}</>
        )}
      </div>
    </Card>
  )
}

export default SubscriptionCard
